import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  unarchiveCustomSurveyTemplate,
  type CustomSurveyTemplate,
} from '../../api/customSurveyTemplates';
import { customSurveyTemplateKeys } from '../queries/queryKeys';

export const useUnarchiveCustomSurveyTemplateMutation = (options?: {
  onSuccess?: (data: CustomSurveyTemplate) => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => unarchiveCustomSurveyTemplate(id),
    onSuccess: (data) => {
      // Invalidate queries to refetch with updated archive status
      queryClient.invalidateQueries({ queryKey: customSurveyTemplateKeys.detail(data.id) });
      queryClient.invalidateQueries({ queryKey: customSurveyTemplateKeys.lists() });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      options?.onError?.(error);
    },
  });
};
